<template>
	<div>
		<div v-if="item.images && item.images.length > 0" class="row g-3">
			<div
				v-for="(image, keyimage) in filteredImages"
				:key="keyimage"
				:class="{
					'col-sm-12 image-top': keyimage === 0,
					'col-6 image-bottom': keyimage > 0,
					'svg-class': image.image.url.endsWith('.svg'),
					'is-fullimage': keyimage === 0 && filteredImages.length === 1
				}"
			>
				<NuxtImg
					v-if="image.image.url"
					:src="completeImageUrl(image.image.url)"
					:alt="image.image.metadata['alt'] || ''"
          :title="image.image.metadata['title'] || ''"
					class="w-100"
					loading="lazy"
					sizes="1360px"
				/>
				<img
					src="/images/logo.gif"
					width="80"
					height="80"
					class="mb-3 swiper-lazy-preloader"
				/>
			</div>
		</div>
		<div v-else class="no-img-projects">
			<p>Keine Bilder zum Projekt in der API hinterlegt</p>
		</div>
		<div v-if="item.video" class="responsive-video responsive-video--youtube">
			<ScriptYouTubePlayer :video-id="item.video">
				<template #awaitingLoad>
					<div class="position-absolute top-50 start-50 translate-middle" style="height:48px;width:68px;">
						<svg height="100%" width="100%" viewBox="0 0 68 48" version="1.1">
							<path fill="#f00" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" />
							<path fill="#fff" d="M 45,24 27,14 27,34" />
						</svg>
					</div>
				</template>
			</ScriptYouTubePlayer>
		</div>
	</div>
</template>

<script>
import { usePimcoreAssetUrl } from '~/composables/usePimcoreAssetUrl'

export default {
	// eslint-disable-next-line vue/require-prop-types
	props: ['item'],
	computed: {
		filteredImages() {
			return this.item.images && this.item.images.length > 0
				? this.item.images.slice(0, 3)
				: []
		}
	},
	methods: {
		completeImageUrl(imagePath) {
			return usePimcoreAssetUrl(imagePath) || '/images/no-image-placeholder.svg'
		}
	}
}
</script>
<style lang="scss">
.image-top {
	img {
		height: 234px;
		object-fit: cover;
	}
}
.image-bottom {
	img {
		height: 168px;
		object-fit: cover;
	}
}
.is-fullimage {
	img {
		height: 60vh;
		object-fit: cover;
		object-position: top;
	}
}
.svg-class {
	img {
		object-fit: contain;
	}
}
.no-img-projects {
	display: flex;
	align-items: center;
	min-height: 50vh;
	justify-content: center;
}
</style>
